import * as Yup from "yup";
import dayjs from "dayjs";
import { getShiftDurationInMinutes } from "./commonMethods";

export const LeadSchemaAdmin = Yup.object().shape({
  source: Yup.string().min(3).optional().label("Source"),
  name: Yup.string().min(3).required("Project is Required"),
  mobile: Yup.number().min(5).required("Mobile is Required"),
  code: Yup.string().required("Code is Required"),
  clientName: Yup.string().min(3).required("Client Name is Required"),
  clientEmail: Yup.string()
    .email("Invalid email")
    .required("Client Email is Required"),
  type: Yup.string().required("Type is required"),
  whatsapp: Yup.string().min(5).required("Whatsapp is Required"),
  srManager: Yup.string().required("Sr Manager is required"),
});

export const LeadSchema = Yup.object().shape({
  source: Yup.string().min(3).optional().label("Source"),
  name: Yup.string().min(3).required("Name is Required"),
  mobile: Yup.number().min(5).required("Mobile is Required"),
  code: Yup.string().required("Code is Required"),
  clientName: Yup.string().min(3).required("Client Name is Required"),
  clientEmail: Yup.string()
    .email("Invalid email")
    .required("Client Email is Required"),
  type: Yup.string().required("Type is required"),
  whatsapp: Yup.string().min(5).required("Whatsapp is Required"),
  srManager: Yup.string(),
});

export const EventSchema = Yup.object().shape({
  title: Yup.string()
    .min(3, "Title must be at least 3 characters")
    .required("Title is required"),
  eventType: Yup.string().required("Event type is required"),
  description: Yup.string().nullable(),

  startDateTime: Yup.date().required("Start Date & Time is required"),
  endDateTime: Yup.date()
    .nullable()
    .min(Yup.ref("startDateTime"), "End Date must be after Start Date"),

  timeZone: Yup.string().required("Time Zone is required"),
  country: Yup.string().required("Country is required"),
  city: Yup.string().required("City is required"),
  location: Yup.string().nullable(),

  organizer: Yup.string().nullable(),
  contactEmail: Yup.string().email("Invalid email address").nullable(),
  contactPhone: Yup.string().nullable(),

  capacity: Yup.number()
    .nullable()
    .transform((v, o) => (o === "" ? null : v))
    .positive("Capacity must be positive"),

  registrationDeadline: Yup.date()
    .nullable()
    .transform((v, o) => (o === "" ? null : v)),
  // .max(
  //   Yup.ref("startDateTime"),
  //   "Registration deadline must be before the event start time"
  // ),
  tags: Yup.string().nullable(),
});

export const MeetingSchema = Yup.object().shape({
  lead: Yup.string().required("Lead is required"),
  productPitch: Yup.string().required("Product Pitch is required"),
  clientAddress: Yup.string().required("Client Address is required"),
  clientCity: Yup.string().required("Client City is required"),
  clientCountry: Yup.string().required("Client Country is required"),
  status: Yup.string().required("Status is required"),
  scheduleDate: Yup.date(),
  location: Yup.string().required("Meeting Location is required"),
  remarks: Yup.string().required("Remarks is required"),
  agents: Yup.array(),
});

export const BookingSchema = Yup.object().shape({
  developer: Yup.string(),
  relationshipManager: Yup.string(),
  meeting: Yup.string().required("Meeting is required"),
  projectName: Yup.string().required("Project Name is required"),
  unit: Yup.string().required("Unit is required"),
  areaSQFT: Yup.number()
    .min(100, "Area SQFT is required")
    .required("Area SQFT is required"),
  total: Yup.number()
    .min(1000, "Total must be greater than or equals to 1000")
    .required("Total is required"),
  propertyDetails: Yup.string().required("Booking Details is required"),
  paymentPlan: Yup.string().required("Payment Plan is required"),
  paymentMode: Yup.string().required("Payment Mode is required"),
  token: Yup.boolean().required("Token is required"),
  bookingAmount: Yup.number().required("Booking Amount is required"),
  // passback: Yup.number().required("Passback is required"),
  // passbackPerc: Yup.number(),
  clientLoyalty: Yup.number().required("Client Loyalty is required"),
  clientLoyaltyPerc: Yup.number().required("Client Loyalty % is required"),
  brokerReferral: Yup.number().required("Broker Referral is required"),
  brokerReferralPerc: Yup.number().required("Client Loyalty % is required"),
  commission: Yup.number().required("Commission is required"),
  commissionPerc: Yup.number(),
  date: Yup.date(),
  inputStatus: Yup.string(),
  agents: Yup.array(),
});

// export const BookingSchema = Yup.object().shape({
//   developer: Yup.string().required("Developer is required"),
//   relationshipManager: Yup.string(),
//   meeting: Yup.string().required("Meeting is required"),
//   projectName: Yup.string()
//     .matches(/^[A-Za-z\s]+$/, "Project Name can only contain letters")
//     .required("Project Name is required"),
//   unit: Yup.string().required("Unit is required"),
//   areaSQFT: Yup.number()
//     .min(100, "Area SQFT is required")
//     .required("Area SQFT is required"),
//   total: Yup.number()
//     .min(1000, "Total must be greater than or equals to 1000")
//     .required("Total is required"),
//   propertyDetails: Yup.string().required("Booking Details is required"),
//   paymentPlan: Yup.string()
//     // .matches(/^[A-Za-z\s]+$/, "Payment Plan can only contain letters")
//     .required("Payment Plan is required"),
//   paymentMode: Yup.string().required("Payment Mode is required"),
//   token: Yup.boolean().required("Token is required"),
//   bookingAmount: Yup.number()
//     .required("Booking Amount is required")
//     .test(
//       "is-less-than-total",
//       "Booking Amount must be less than Total",
//       function (value) {
//         const { total } = this.parent;
//         return value < total;
//       }
//     ),
//   clientLoyalty: Yup.number().required("Client Loyalty is required"),
//   clientLoyaltyPerc: Yup.number().required("Client Loyalty % is required"),
//   brokerReferral: Yup.number().required("Broker Referral is required"),
//   brokerReferralPerc: Yup.number().required("Client Loyalty % is required"),
//   commission: Yup.number().required("Commission is required"),
//   commissionPerc: Yup.number(),
//   date: Yup.date(),
//   inputStatus: Yup.string(),
//   agents: Yup.array(),
// });

export const UserSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid Email").required("Email is required"),
  role: Yup.string().required("Role is required"),
});

export const TeamSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  srManagerId: Yup.string().required("Sr Manager is required"),
  managerId: Yup.string(),
  // managerId: Yup.string().required("Manager is required"),
  teamLeadId: Yup.string(),
  agents: Yup.array(),
});

export const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().min(8).required("Old Password is required"),
  newPassword: Yup.string().min(8).required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Please confirm your password"),
});

export const ForgetChangeSchema = Yup.object().shape({
  password: Yup.string().min(8).required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Please confirm your password"),
});

export const RescheduleSchema = Yup.object().shape({
  scheduleDate: Yup.string().required("Date and Time is required"),
  location: Yup.string().required("Location is required"),
  remarks: Yup.string().required("Remarks is required"),
});

export const HrmsAddUserSchema = Yup.object().shape({
  name: Yup.string().required("First Name is Required"),
  email: Yup.string().email("Invalid Email").required("Email is required"),
  //role: Yup.string().required("Role is Required")
});

export const InterviewSchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  date: Yup.date()
    .required("Interview date and time is required")
    .typeError("Valid date and time required"),
  referredBy: Yup.string().required("Referred By is required"),
  qualification: Yup.string().required("Qualification is required"),
  beforeInterview: Yup.string().required("CV is required"),
  realEstateExperience: Yup.number()
    .typeError("Experience must be a number")
    .min(0, "Experience cannot be negative")
    .required("Real estate experience is required"),
  designation: Yup.string().required("Designation is required"),
});

export const PostInterviewSchema = Yup.object({
  remarks: Yup.string().required("Remarks are required"),
  reportingManager: Yup.string().required("Reporting Manager is required"),
  salaryOffered: Yup.string()
    .matches(/^\d+$/, "Salary must be a number")
    .required("Salary Offered is required"),
  joiningDate: Yup.string().required("Joining Date is required"),
  offerAccepted: Yup.string()
    .oneOf(["yes", "no"], "Select Yes or No")
    .required("Offer acceptance is required"),
  offerLetter: Yup.string().required("Offer letter file is required"),
  afterInterview: Yup.string().required("After interview file is required"),
  pnl: Yup.string().required("PNL is required"),
});

export const RescheduleInterviewSchema = Yup.object({
  remarks: Yup.string().required("Remarks are required"),
  time: Yup.date()
    .required("Date and time is required")
    .typeError("Valid date and time required"),
});

export const ReferralEditSchema = Yup.object().shape({
  clientName: Yup.string().required("Name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  passportNumber: Yup.string().required("Passport number is required"),
  eidNumber: Yup.string().required("EID number is required"),
  nationality: Yup.string().required("Nationality is required"),
  address: Yup.string().required("Address is required"),
  passportDocument: Yup.string().required("Passport upload is required"),
  visaDocument: Yup.string().required("Visa upload is required"),
  eidDocument: Yup.string().required("EID upload is required"),
});

export const InterviewStatusSchema = Yup.object({
  remarks: Yup.string().required("Remarks are required"),
  newStatus: Yup.string().required("Status is Required"),
});

export const HolidaySchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  startDate: Yup.date()
    .required("Start date is required")
    .typeError("Valid date required"),
  endDate: Yup.date()
    .required("End date is required")
    .typeError("Valid date required")
    .min(Yup.ref("startDate"), "End date must be after start date"),
});

export const HolidayAssignmentSchema = Yup.object()
  .shape({
    users: Yup.array(),
    departments: Yup.array(),

    excludedHolidays: Yup.array(),

    customHolidays: Yup.array()
      .of(
        Yup.object().shape({
          holiday: Yup.string().required("Holiday ID missing"),
          startDate: Yup.string().nullable(),
          endDate: Yup.string().nullable(),
        }),
      )
      .test(
        "customHolidays-valid-dates",
        "Start and End date are required for all custom holidays",
        (value) => {
          if (!value || value.length === 0) return true;
          return value.every((item) => !!item.startDate && !!item.endDate);
        },
      ),
  })
  .test(
    "users-or-departments-required",
    "Select at least one user or department",
    function (value) {
      const users = value.users || [];
      const departments = value.departments || [];
      return users.length > 0 || departments.length > 0;
    },
  );

export const ShiftSchema = Yup.object().shape({
  name: Yup.string().required("Shift Name is required"),
  startTime: Yup.string().required("Start time is required"),
  endTime: Yup.string()
    .required("End time is required")
    .test("shift-duration", "Invalid shift duration", function (value) {
      const { startTime } = this.parent;
      if (!startTime || !value) return true;

      const today = dayjs().format("YYYY-MM-DD");
      const start = dayjs(`${today}T${startTime}`);
      const end = dayjs(`${today}T${value}`);

      const duration = getShiftDurationInMinutes(start, end);

      if (duration < 60) {
        return this.createError({
          message: "Shift duration must be at least 1 hour",
        });
      }
      if (duration > 16 * 60) {
        return this.createError({
          message: "Shift duration cannot exceed 16 hours",
        });
      }
      return true;
    }),
});

// export const offDaysSchema = Yup.object()
//   .shape({
//     users: Yup.array(),
//     departments: Yup.array(),
//     offDayType: Yup.string().oneOf(
//       ["every", "custom", ""],
//       "Invalid off day type"
//     ),

//     everyDays: Yup.array().when("offDayType", {
//       is: "every",
//       then: Yup.array().min(1, "Please select at least one day"),
//       otherwise: Yup.array(),
//     }),

//     customDays: Yup.array().when("offDayType", {
//       is: "custom",
//       then: Yup.array()
//         .min(1, "Please add at least one custom day")
//         .of(
//           Yup.object().shape({
//             week: Yup.string().required("Week is required"),
//             day: Yup.string().required("Day is required"),
//           })
//         ),
//       otherwise: Yup.array(),
//     }),
//   })
//   // ✅ Custom test to ensure one of users or departments is selected (not both or none)
//   .test(
//     "either-users-or-departments",
//     "Please select either users or departments (not both)",
//     function (values) {
//       const hasUsers = values.users && values.users.length > 0;
//       const hasDepartments =
//         values.departments && values.departments.length > 0;
//       return (hasUsers || hasDepartments) && !(hasUsers && hasDepartments);
//     }
//   );

export const AllowanceSchema = Yup.object().shape({
  name: Yup.string().required("First name is required"),
  description: Yup.string().required("Description is required"),
});

export const updateSalaryStatusSchema = Yup.object().shape({
  status: Yup.string().required("Status is required"),
  paymentMethod: Yup.string().when("status", {
    is: (val) => val?.toLowerCase() === "paid",
    then: (schema) => schema.required("Payment method is required"),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
});

export const dubaiExpoValidationSchema = Yup.object().shape({
  fName: Yup.string().required("First Name is required"),
  lName: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid Email").required("Email is required"),
  phone: Yup.string().required("Phone Number is required"),
  eventId: Yup.string().required("Event is required"),
  date: Yup.string().required("Date is required"),
  startTime: Yup.string().required("Slot is required"),
  purpose: Yup.string().required("Purpose is required"),
  budget: Yup.string().required("Budget is required"),
  preference: Yup.string().required("Preference is required"),
  howSoon: Yup.string().required("How Soon is required"),
  ref: Yup.string(),
});

export const eventRegistrationSchema = Yup.object().shape({
  fName: Yup.string().required("First Name is required."),
  lName: Yup.string().required("Last Name is required."),
  email: Yup.string()
    .email("Invalid email address.")
    .required("Email is required."),
  phone: Yup.string().required("Phone number is required."),
  countryCode: Yup.string().required("Country code is required."),
  eventId: Yup.string().required("Event is required."),
  date: Yup.string().required("Date is required."),
  slots: Yup.string().required("Slots are required."),
  attendType: Yup.string().required("Attend Type is required."),
  referredBy: Yup.string(),
  referredId: Yup.string().required("Referred By is required."),
});
